/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LedgerStandingRow
 */
export interface LedgerStandingRow {
    /**
     * Opaque row identity, stable for the same member across refetches on this board so a client can animate movement. A one-way digest keyed by board id — not a user id and not reversible.
     * @type {string}
     * @memberof LedgerStandingRow
     */
    rowId: string;
    /**
     * 
     * @type {number}
     * @memberof LedgerStandingRow
     */
    rank: number;
    /**
     * Server-resolved nickname. Raw user ids are never exposed on public rows.
     * @type {string}
     * @memberof LedgerStandingRow
     */
    displayName: string;
    /**
     * Profile image (or gravatar). Absent renders the initial.
     * @type {string}
     * @memberof LedgerStandingRow
     */
    avatarUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof LedgerStandingRow
     */
    points: number;
    /**
     * 
     * @type {boolean}
     * @memberof LedgerStandingRow
     */
    isMe: boolean;
    /**
     * Present ONLY on the authenticated caller's own row — the sibling boards' anti-enumeration pattern.
     * @type {string}
     * @memberof LedgerStandingRow
     */
    userId?: string;
    /**
     * The member's earned badge total — drives the placement rosette beside the name. Absent or 0 renders no mark.
     * @type {number}
     * @memberof LedgerStandingRow
     */
    badgeCount?: number;
}

/**
 * Check if a given object implements the LedgerStandingRow interface.
 */
export function instanceOfLedgerStandingRow(value: object): value is LedgerStandingRow {
    if (!('rowId' in value) || value['rowId'] === undefined) return false;
    if (!('rank' in value) || value['rank'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('isMe' in value) || value['isMe'] === undefined) return false;
    return true;
}

export function LedgerStandingRowFromJSON(json: any): LedgerStandingRow {
    return LedgerStandingRowFromJSONTyped(json, false);
}

export function LedgerStandingRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): LedgerStandingRow {
    if (json == null) {
        return json;
    }
    return {
        
        'rowId': json['rowId'],
        'rank': json['rank'],
        'displayName': json['displayName'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'points': json['points'],
        'isMe': json['isMe'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'badgeCount': json['badgeCount'] == null ? undefined : json['badgeCount'],
    };
}

export function LedgerStandingRowToJSON(json: any): LedgerStandingRow {
    return LedgerStandingRowToJSONTyped(json, false);
}

export function LedgerStandingRowToJSONTyped(value?: LedgerStandingRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rowId': value['rowId'],
        'rank': value['rank'],
        'displayName': value['displayName'],
        'avatarUrl': value['avatarUrl'],
        'points': value['points'],
        'isMe': value['isMe'],
        'userId': value['userId'],
        'badgeCount': value['badgeCount'],
    };
}

